export enum HeaderMenuTheme {
  SolidWhite = 'solidWhite',
  SolidBeige = 'solidBeige',
  Transparent = 'transparent',
}
